import { updateFile, updateSelectedFile } from '../actions/organization'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getIDToken } from '../utils/AuthUtil'
import { RootState } from '../store'

const BASE_URL = process.env.REACT_APP_BASE_URL

const getSignedUrlAsync = async (payload: {
  filename: string
}): Promise<{ thumbnailSignedUrl: string }> => {
  const response = await fetch(`${BASE_URL}/api/thumbnails/signedUrl`, {
    method: 'POST',
    headers: {
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${await getIDToken()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ filename: payload.filename }),
  })

  if (!response.ok) {
    throw new Error('Failed to get signed URL')
  }

  const data = await response.json()

  return data
}

export const uploadThumbnailAsync = createAsyncThunk(
  'thumbnails/uploadThumbnailAsync',
  async (
    payload: { fileId: number; thumbnail: File },
    { dispatch, getState },
  ) => {
    const { fileId, thumbnail } = payload

    try {
      const { thumbnailSignedUrl } = await getSignedUrlAsync({
        filename: thumbnail.name,
      })

      await fetch(thumbnailSignedUrl, {
        method: 'PUT',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': thumbnail.type,
        },
        body: thumbnail,
      })

      const file = {
        id: fileId,
        data: { thumbnail_path: `${thumbnail.name}` },
      }

      const response = await fetch(`${BASE_URL}/api/file/update`, {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${await getIDToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(file),
      })
      const data = await response.json()

      dispatch(updateFile({ fileId, newFile: data }))

      const state = getState() as RootState
      const selectedFile = state.organization.selectedFile
      if (selectedFile?.id === payload.fileId) {
        dispatch(updateSelectedFile(data))
      }
    } catch (error) {
      console.error('Error during uploading thumbnail: ', error)
    }
  },
)
